import { io } from "socket.io-client";

let socket;

export const connectSocket = (token) => {

    // console.log("Socket Token:", token);

  // Prevent creating multiple socket connections
  if (socket?.connected) {
    return socket;
  }

  socket = io(
    import.meta.env.VITE_API_SOCKET_URL,
    {
      auth: {
        token,
      },

      transports: [
        "websocket",
        "polling",
      ],

      reconnection: true,

      reconnectionAttempts: 5,

      reconnectionDelay: 1000,

      timeout: 20000,
    }
  );

  socket.on(
    "connect",
    () => {
      console.log(
        "Admin connected to support chat socket:",
        socket.id
      );
    }
  );

  socket.on(
    "connect_error",
    (error) => {
      console.error(
        "Support socket connection error:",
        error.message
      );
    }
  );

  socket.on(
    "disconnect",
    (reason) => {
      console.warn(
        "Socket disconnected:",
        reason
      );
    }
  );

  return socket;
};


export const getSocket =
() => socket;


export const disconnectSocket =
() => {

  if (socket) {

    socket.disconnect();

    socket = null;

    console.log(
      "Socket disconnected and cleaned up"
    );
  }
};